import { render, staticRenderFns } from "./AccountInvestigationHelpPopup.vue?vue&type=template&id=933bded6&scoped=true&"
import script from "./AccountInvestigationHelpPopup.vue?vue&type=script&lang=js&"
export * from "./AccountInvestigationHelpPopup.vue?vue&type=script&lang=js&"
import style0 from "./AccountInvestigationHelpPopup.vue?vue&type=style&index=0&id=933bded6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933bded6",
  null
  
)

export default component.exports